import React, { useEffect } from 'react';
const contentStyle: React.CSSProperties = {
    height: 'auto',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: '#364d79',
  };
import { Button, Card, Carousel, Col, Divider, Row, Space, Tooltip } from 'antd';
import Meta from 'antd/es/card/Meta';
import { useMediaQuery } from '../../hooks/MediaQuery.hook';
import './index.css'
import { Link } from 'react-router-dom';
import { blogs, DEFAULT_LEAGUE_LINK, DEFAULT_TEAM_LINK, PAGE_TITLES } from '../../utils/constant';
import { styles } from '../../styles';
import Seo from '../../components/Seo';
import { PAGE_SEO, SITE_URL } from '../../utils/seo';

export default function Blogs() {
    const matches = useMediaQuery('(min-width: 1000px)');
    const buttonSize = matches ? 'large': 'small';

    useEffect(()=>{
        document.title = PAGE_TITLES.BLOGS;
    },[]);

    return (
        <>
            <Seo
                title={PAGE_SEO.BLOGS.title}
                description={PAGE_SEO.BLOGS.description}
                canonical={`${SITE_URL}/blogs`}
            />
            <h1 style={{ color: '#fff', fontSize: matches ? '28px' : '22px', marginTop: '12px' }}>
                Sports news and commentary
            </h1>
            <Row style={{display: 'flex', justifyContent: 'center', marginTop: '10px'}}>
                <Col span={16} style={{paddingRight: '12px'}}>
                <Row className='flex-display'>
                    <Space style={matches ? { marginBottom:'15px'}: { marginBottom: '5px'}} wrap>
                    <Button className='time-button' style={{ backgroundColor: '#202024', color:'#c7bdbd' }} shape="round" size={buttonSize}>
                        <Link to={DEFAULT_LEAGUE_LINK} >Leagues</Link>
                    </Button>
                    <Button className='time-button' style={{ backgroundColor: '#202024', color:'#c7bdbd' }} shape="round" size={buttonSize}>
                        <Link to={DEFAULT_TEAM_LINK} >Teams</Link>
                    </Button>
                    <Button className='time-button' style={{ backgroundColor: '#202024', color:'#c7bdbd' }} shape="round" size={buttonSize}>
                        <Link to={'/leagues/standings'} >Standings</Link>
                    </Button>
                    </Space>
                </Row>
                {/* <AdSenseBanner slot={ADS.MAIN.SLOT} type={ADS.MAIN.TYPE} /> */}
                </Col>
            </Row>
            <Row style={{marginTop: '10px'}}>
                <Col span={4} style={{justifyContent: 'center'}}>
                </Col>
                <Col span={16} style={{justifyContent: 'center'}}>
                    <Col span={24}>
                    <Carousel autoplay style={{ borderRadius: '10px',justifyContent:'center' }}>
                        <div style={contentStyle}>
                            <Link to={`/blogs/${blogs[blogs.length - 1]?.url}-${blogs[blogs.length - 1]?.id}`}>
                            <div style={styles.flexDisplay}>
                                <img
                                src={blogs[blogs.length - 1]?.image}
                                alt={blogs[blogs.length - 1]?.title}
                                style={{ width: '80%', height: 'auto', borderRadius: '10px' }}
                                />
                            </div>
                                <div style={{...styles.flexDisplay}}>
                                    <div
                                    style={{
                                        width: matches ? '80%': '',
                                        color: 'white',
                                        backgroundColor: 'rgba(19, 18, 18, 0.5)', // Background transparency
                                        marginTop: '2px',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        textAlign: 'left'
                                    }}
                                    >
                                    <p className='blog-title-crousal' style={{margin: matches ? '10px': '0px'}}>{blogs[0]?.title?.toUpperCase()}</p>
                                    {matches && <p
                                        style={{
                                        margin: '0',
                                        color: '#ddd',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 3,
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        }}
                                    >
                                        {blogs[blogs.length - 1]?.description}
                                    </p>}
                                    </div>
                                </div>
                            </Link>
                        </div>
                    {/* {blogs?.map((blog: any, index: number) => (
                            <div key={index} style={contentStyle}>
                                <Link to={`/blogs/${blog?.url}-${blog?.id}`}>
                                <div style={styles.flexDisplay}>
                                    <img
                                    src={blog?.image}
                                    alt={blog?.title}
                                    style={{ width: '80%', height: 'auto', borderRadius: '10px' }}
                                    />
                                </div>
                                    <div style={{...styles.flexDisplay}}>
                                        <div
                                        style={{
                                            width: matches ? '80%': '',
                                            color: 'white',
                                            backgroundColor: 'rgba(19, 18, 18, 0.5)', // Background transparency
                                            marginTop: '2px',
                                            padding: '10px',
                                            borderRadius: '5px',
                                            textAlign: 'left'
                                        }}
                                        >
                                        <p className='blog-title-crousal' style={{margin: matches ? '10px': '0px'}}>{blog?.title?.toUpperCase()}</p>
                                        {matches && <p
                                            style={{
                                            margin: '0',
                                            color: '#ddd',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            }}
                                        >
                                            {blog?.description}
                                        </p>}
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        
                    ))} */}
                    </Carousel>

                    </Col>
                    <Col></Col>                                         
                </Col>
            </Row>
            <Divider></Divider>
            <Row>
                <Col span={4} style={{justifyContent: 'center'}}>
                </Col>
                <Col span={16} style={{justifyContent: 'center'}}>
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        {blogs.slice(0,blogs.length - 1)?.map((blog: any, index: number)=>(
                            <Col key={index} span={matches ? 8: 24}>
                                <Link to={`/blogs/${blog?.url}-${blog?.id}`}>
                                    <Card
                                        hoverable
                                        style={{ marginBottom: '10px', background: 'rgba(19, 18, 18, 0.5)'}}
                                        cover={<img alt={blog?.title} src={blog?.image} />}
                                    >
                                        <Meta
                                        title={<Tooltip title={blog?.title}>
                                        <span style={{
                                                color: 'white',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'pre-wrap'
                                                }}>{blog?.title}</span>
                                        </Tooltip>} 
                                        />
                                    </Card>
                                </Link>
                        </Col>
                        ))}
                    </Row>                                          
                </Col>
                <Col span={4} style={{justifyContent: 'center'}}>
                    {/* <Carousel autoplay>
                        <div>
                        <h3 style={contentStyle}>1</h3>
                        </div>
                        <div>
                        <h3 style={contentStyle}>2</h3>
                        </div>
                        <div>
                        <h3 style={contentStyle}>3</h3>
                        </div>
                        <div>
                        <h3 style={contentStyle}>4</h3>
                        </div>
                    </Carousel>                                         */}
                </Col>
            </Row>
        </>
    );
};